import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SAVES_SCREEN_WORK } from '@rcs/shared';
import { Observable, tap } from 'rxjs';
import { UnsavedWorkService } from '../base/shell/unsaved-work.service';

const READ_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);
// `confirm` and `attach` are here because a screen whose save is spelled that way was left
// looking dirty after it had saved: confirming a Customer RFQ revision wrote the change and
// then warned that leaving would lose it.
const SAVE_ACTION =
  /^(save|create|update|add(?!ress)|insert|upsert|submit|publish|delete|remove|approve|reject|send|change|assign|import|upload|cancel|close|complete|confirm|convert|attach|link|unlink|mark|merge|post|record|release|edit|modify|set|resolve|correct)/i;
const BACKGROUND =
  /hubs\/|negotiate|notification|chat|geraltai|telemetry|\/session\/|\/ping\b|heartbeat|mru|presence|screenclick|savenav|clearnav|audit|tracking|paginat|getall|bysearch/i;
const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-/i;

export function isSaveRequest(method: string, url: string): boolean {
  if (READ_METHODS.has(method.toUpperCase())) return false;
  const path = url.split(/[?#]/)[0];
  if (BACKGROUND.test(path)) return false;
  const words = path
    .split('/')
    .filter((s) => /^[a-z][a-z0-9_-]*$/i.test(s) && !GUID.test(s) && !/^v\d+$/i.test(s));
  const action = words[words.length - 1] ?? '';
  return SAVE_ACTION.test(action);
}

@Injectable()
export class UnsavedWorkInterceptor implements HttpInterceptor {
  private readonly work = inject(UnsavedWorkService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const screen = this.work.current();
    const saves = req.context.get(SAVES_SCREEN_WORK) || isSaveRequest(req.method, req.url);
    if (!screen || this.work.dialogOpen() || !saves) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && event.ok) this.work.markClean(screen);
      })
    );
  }
}
